<template>
  <div class="row">
    <div class="card-body p-0">
      <div class="row">
        <div class="form-group col-md-12">
          <button type="button" class="btn btn-primary" @click="addPath()" v-if="paths.length == 0">
            Agregar Puntos
          </button>
          <button type="button" class="btn btn-danger" @click="removePath()">Eliminar Puntos</button>
        </div>
        <div class="col-md-8">
          <gmap-map :center="center" :zoom="17" style="width: 100%; height: 400px" ref="map">
            <gmap-polygon
              v-if="paths.length > 0"
              :paths="paths"
              :editable="true"
              @paths_changed="editarPoligono($event)"
              @rightclick="handleClickForDelete"
              ref="polygon"
            >
            </gmap-polygon>
          </gmap-map>
        </div>
        <div class="col-md-4">
          <table class="table table-bordered table-striped table-hover table-sm">
            <thead>
              <tr>
                <th class="col-4">Posicion</th>
                <th class="col-4">Longitud</th>
                <th class="col-4">Latitud</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="puntos in paths[0]" :key="puntos.id" class="text-center">
                <td v-text="puntos.posicion"></td>
                <td v-text="puntos.lng"></td>
                <td v-text="puntos.lat"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TepBloqueMapPoli",
  props: {
    entity: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      center: { lat: 4.651371, lng: -74.071509 },
      paths: [],
      mvcPaths: null,
    };
  },
  computed: {
    polygonPaths() {
      if (!this.mvcPaths) return null;
      let paths = [];
      for (let i = 0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({
            id: j,
            lat: point.lat(),
            lng: point.lng(),
            posicion: j + 1,
          });
        }
        paths.push(path);
      }
      return paths;
    },
  },
  watch: {
    polygonPaths(paths) {
      if (paths) this.paths = paths;
    },
  },
  methods: {
    addPath() {
      var bounds = this.$refs.map.$mapObject.getBounds();
      var northEast = bounds.getNorthEast();
      var southWest = bounds.getSouthWest();
      var center = bounds.getCenter();
      var degree = this.paths.length + 1;
      var f = Math.pow(0.66, degree);

      var path = [
        { lng: center.lng(), lat: (1 - f) * center.lat() + f * northEast.lat(), posicion: 1 },
        {
          lng: (1 - f) * center.lng() + f * southWest.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
          posicion: 2,
        },
        {
          lng: (1 - f) * center.lng() + f * northEast.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
          posicion: 3,
        },
      ];

      this.paths.push(path);
    },
    removePath() {
      this.paths.splice(this.paths.length - 1, 1);
    },
    editarPoligono(mvcPaths) {
      this.mvcPaths = mvcPaths;
    },
    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex);
      }
    },
    initPaths() {
      let puntos = this.entity?.geocerca?.puntos ?? null;
      if (puntos) {
        let paths = [];
        for (let i = 0; i < puntos.length; i++) {
          paths.push({
            lng: parseFloat(puntos[i]["longitud"]),
            lat: parseFloat(puntos[i]["latitud"]),
            posicion: parseFloat(puntos[i]["posicion"]),
          });
        }
        this.paths.push(paths);
        this.center = { lng: parseFloat(puntos[0]["longitud"]), lat: parseFloat(puntos[0]["latitud"]) };
      } else if (this.entity && this.entity.geocerca) {
        this.center = {
          lng: parseFloat(this.entity.geocerca.longitud),
          lat: parseFloat(this.entity.geocerca.latitud),
        };
      }
    },
  },
  mounted() {
    this.initPaths();
  },
};
</script>
